module.exports = __webpack_public_path__ + "img/bannernew.66f4bb71.jpg";